import {
  requireFirstRow,
  requireRows,
  type SupabaseDataProvider,
} from './data-provider';

// One of the signed-in adult's own messages, with the reply if staff have
// answered it (migration 202610040002).
export type MySupportMessage = {
  id: string;
  createdAt: string;
  message: string;
  staffReply: string | null;
};

export type SupportMessageResult =
  { ok: true } | { ok: false; reason: 'rate_limited' | 'invalid' };

export function createSupportMessagesService(provider: SupabaseDataProvider) {
  return {
    async submit(message: string, page: string): Promise<SupportMessageResult> {
      const result = await provider.rpc('submit_support_message', {
        p_message: message,
        p_page: page,
      });
      const row = requireFirstRow(result);
      if (row.denial_code === 'RATE_LIMITED')
        return { ok: false, reason: 'rate_limited' };
      if (typeof row.denial_code === 'string')
        return { ok: false, reason: 'invalid' };
      return { ok: true };
    },
    async listMine(): Promise<MySupportMessage[]> {
      const result = await provider.rpc('list_my_support_messages', {});
      return requireRows(result).map((row) => {
        if (
          typeof row.id !== 'string' ||
          typeof row.created_at !== 'string' ||
          typeof row.message !== 'string'
        )
          throw new Error('INVALID_RESPONSE');
        return {
          id: row.id,
          createdAt: row.created_at,
          message: row.message,
          staffReply:
            typeof row.staff_reply === 'string' ? row.staff_reply : null,
        };
      });
    },
  };
}

export type SupportMessagesService = ReturnType<
  typeof createSupportMessagesService
>;
